import { render } from "./PairInput.vue?vue&type=template&id=8cdf5fe0"
import script from "./PairInput.vue?vue&type=script&lang=js"
export * from "./PairInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__